module.exports = __webpack_public_path__ + "static/media/fassb-design-process.77003588.png";